import { ChannelType } from '~/constants';
import { getMWDomain } from '~/helpers/common';

const { REACT_APP_DOMAIN } = process.env;

const HELLO_MESSAGE = 'Hello MessageWhiz';

export const agentLinkResolvers = {
  IOS: (vln) => `sms:${vln}&body=${encodeURI(HELLO_MESSAGE)}`,
  ANDROID: (vln) => `sms:${vln}?body=${encodeURI(HELLO_MESSAGE)}`,
  RCS: (agentID) =>
    `${getMWDomain() || REACT_APP_DOMAIN}/public/initialize-rcs/${agentID}`,
  SMS: (vln) => `SMSTO:${vln}:${HELLO_MESSAGE}`,
  TELEGRAM: (bot_name) => `https://t.me/${bot_name}`,
  WHATSAPP: (sender_phone) => `https://wa.me/${sender_phone}`,
};

export const getOptInLink = (agent) => {
  const {
    id: agentID,
    channel_type,
    config: { vln, bot_name, sender_phone },
  } = agent;

  const mapChannelTypeToLink = {
    [ChannelType.SMS]: agentLinkResolvers.SMS(vln),
    [ChannelType.TG]: agentLinkResolvers.TELEGRAM(bot_name),
    [ChannelType.WA]: agentLinkResolvers.WHATSAPP(sender_phone),
    [ChannelType.RCS]: agentLinkResolvers.RCS(agentID),
  };

  return mapChannelTypeToLink[channel_type] ?? null;
};
